import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-error-blocking-dialog',
  templateUrl: './error-blocking-dialog.component.html',
  styleUrls: ['./error-blocking-dialog.component.scss'],
})
export class ErrorBlockingDialogComponent {
  pdvLogo: string = `assets/icons/${environment.logo}`;

  statusIcon: string = 'assets/icons/sad-face.svg';

  headerConfiguration = {
    layoutAlign: 'start start',
    sections: [
      {
        partner: false,
        menu: false,
      },
    ],
  };
}
